import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({ name: 'translateRole' })
export class TranslationPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(roleName: string) {
    return this.translate.instant(`roles.${roleName}`)
  }
}
